import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as url from "api/url";
import { Grid } from "@mui/material";

import { getAllResources } from "action/cultureAction";

import APIutil from "api/APIutils";
import DashboardTable from "./dashboardTable";


export const Dashboard = (params) => {

  const dispatch = useDispatch();
  const labels = useSelector(
    (state) =>
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference
  );
const [dashboardList, setDashboardList] = useState([]);



  async function getDashboardList() {
    const requestBody = url.get_Dashboard_List;
    await APIutil.getDataAPI(requestBody)
      .then((res) => {
        setDashboardList(res);
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  }

  useEffect(() => {
    getDashboardList()
  }, [labels])

  useEffect(() => {
    dispatch(getAllResources());
  }, []);


  return (
    <div
      style={{
        backgroundColor: "#f5f6fa",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "1220px",
          width: "97%",
          minWidth: "650px",
        }}
      >
          <Grid id="tableGrid" container spacing={2}>
            <Grid item xs={12} pt={6}>
              <DashboardTable
                rows={dashboardList}
                labels={labels}
              />
            </Grid>

          </Grid>
      </div>
    </div>
  );
};

export default Dashboard;
